/* global localStorage */
import axios from 'axios';

let API_URL = "";

if (process.env.NODE_ENV === "development") {
   API_URL = "http://localhost:8000/api/v1/";
} else {
   API_URL = "/api/v1/";
}

export const axiosInstance = axios.create({
  baseURL: API_URL
});

axiosInstance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axiosInstance.defaults.xsrfCookieName = 'csrftoken';
axiosInstance.defaults.xsrfHeaderName = 'X-CSRFToken';
axiosInstance.defaults.withCredentials = true;



// WEBPACK FOOTER //
// ./src/axios-auth.js